import { useState, useEffect } from "react";
import CarouselArrowBack from "../../assets/Icon/carousel_arrow_back.png";
import CarouselArrowNext from "../../assets/Icon/carousel_arrow_next.png";
import { ButtonArrow } from "../Button/ButtonArrow";
// import { fetchFromApi } from "../../api/Api";
import { useYouTubePlayer } from "../../hooks/useYouTubePlayer";
import videosData from "../../data/videos.json";

type Video = {
  id_youtube: string;
  title: string;
};

export const Carousel = () => {
  const [videos, setVideos] = useState<Video[]>([]);
  const [current, setCurrent] = useState(0);

  const { iframeRef, isPlaying, pauseVideo } = useYouTubePlayer();

  // useEffect(() => {
  //   const loadVideos = async () => {
  //     try {
  //       const data = await fetchFromApi<Video[]>("videos");
  //       setVideos(data);
  //     } catch (error) {
  //       console.error("Erreur lors du chargement des vidéos :", error);
  //     }
  //   };
  //   loadVideos();
  // }, []);

  useEffect(() => {
    // On utilise directement les données importées
    setVideos(videosData);
  }, []);

  const prevSlide = () => {
    pauseVideo();
    setCurrent((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    pauseVideo();
    setCurrent((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  };

  if (videos.length === 0) {
    return <div className="flex justify-center">Chargement des vidéos...</div>;
  }

  return (
    <div className="bg-p-1 py-5 lg:py-12 mt-5 lg:mt-8 w-full relative">
      <div className="relative w-full max-w-4xl mx-auto overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {videos.map((video, index) => (
            <div key={video.id_youtube} className="w-full flex-shrink-0">
              <iframe
                ref={index === current ? iframeRef : null}
                className="w-full h-[450px] sm:h-[500px] lg:h-[600px] xl:h-[600px] rounded-none lg:rounded-xl"
                src={`https://www.youtube-nocookie.com/embed/${video.id_youtube}?enablejsapi=1&controls=0&modestbranding=1&rel=0`}
                title={video.title}
                frameBorder={0}
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          ))}
        </div>
      </div>

      {!isPlaying && (
        <>
          <ButtonArrow
            onClick={prevSlide}
            position="left"
            icon={CarouselArrowBack}
          />
          <ButtonArrow
            onClick={nextSlide}
            position="right"
            icon={CarouselArrowNext}
          />
        </>
      )}
    </div>
  );
};
